import { Button, Card } from "antd";
import Image2 from "../../../../assets/images/measurement-Image2.png";
import "../style.scss";
import { Col, Row } from "react-bootstrap";
import { PiWarning } from "react-icons/pi";
import SensorAlert from "../../../../assets/images/sensor_alert.png";

const PurchaseCard = () => {
  return (
    <Card className="graph-view-container">
      <Row className="mb-1 d-flex align-items-center">
        <Col md={2}>
          <div className="warning-icon-background">
            <img
              src={SensorAlert}
              alt="Image of an alert machine"
              className="graph-view-image"
            />
          </div>
        </Col>
        <Col md={10}>
          <Row>
            <Col>
              <text className="purchase-card-header">
                AI Stuart: OcenAId is recommending..
              </text>
            </Col>
          </Row>
          {/* <Row><Col><text className="purchase-card-header"></text></Col></Row>
        <Row><Col><text className="purchase-text">Measurement values are above threshold</text></Col></Row> */}
        </Col>
      </Row>
      <Row className="mb-3">
        <Col md={12}>
          <Row className="mb-1">
            <Col>
              <text className="purchase-card-header2">Recommendation:</text>
            </Col>
          </Row>
          <Row>
            <Col>
              <text className="purchase-text">
                Sensor readings show deviations beyond safe thresholds. I
                recommend replacing the sensor to ensure continued accurate
                system performance
              </text>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col>
          <Button
            onClick={() => window.open("https://www.amazon.in", "_blank")}
            type="primary"
            className="purchase-button"
          >
            Purchase Sensor
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default PurchaseCard;
